export * from './ingenieros-agronomos-core-detail.model';
export * from './ingenieros-agronomos-core.model';
